// Gestão DNA (/gestao) — registry único de módulos: cards da home + menu lateral.
// Cada item exige module.verb via usePermV2().can(). NENHUM módulo financeiro aqui.
import {
  GraduationCap,
  Users,
  ClipboardList,
  LifeBuoy,
  ScrollText,
  FileSignature,
  CalendarDays,
  DoorOpen,
  BrainCircuit,
  LayoutGrid,
  ShieldAlert,
} from 'lucide-react';

export const GESTAO_MODULES = [
  {
    key: 'alunos',
    label: 'Alunos',
    description: 'Buscar, cadastrar e editar cadastro, saúde, responsáveis e documentos.',
    icon: GraduationCap,
    module: 'alunos',
    verb: 'visualizar',
    alt: { module: 'busca_alunos', verb: 'visualizar' },
    route: '/gestao/alunos',
    grupo: 'Alunos',
    tone: 'violet',
  },
  {
    key: 'responsaveis',
    label: 'Responsáveis',
    description: 'Cadastro, contatos, endereço e vínculo com os alunos da família.',
    icon: Users,
    module: 'responsaveis',
    verb: 'visualizar',
    route: '/gestao/responsaveis',
    grupo: 'Alunos',
    tone: 'emerald',
  },
  {
    key: 'notas',
    label: 'Consulta de Notas',
    description: 'Notas por aluno, turma, disciplina e período — somente leitura.',
    icon: ClipboardList,
    module: 'central_notas',
    verb: 'visualizar',
    route: '/gestao/notas',
    grupo: 'Pedagógico',
    tone: 'indigo',
    readOnly: true,
  },
  {
    key: 'turmas',
    label: 'Painel da Turma',
    description: 'Notas por disciplina, faltas e recuperação da turma em uma só tela.',
    icon: LayoutGrid,
    module: 'central_notas',
    verb: 'visualizar',
    route: '/gestao/turmas',
    grupo: 'Pedagógico',
    tone: 'teal',
  },
  {
    key: 'ocorrencias',
    label: 'Ocorrências',
    description: 'Registro pedagógico de indisciplina, saúde, atrasos, elogios e comunicados.',
    icon: ShieldAlert,
    module: 'pedagogico',
    verb: 'visualizar',
    route: '/gestao/ocorrencias',
    grupo: 'Pedagógico',
    tone: 'rose',
  },
  {
    key: 'recuperacao',
    label: 'Recuperação',
    description: 'Alunos em recuperação, disciplinas e acompanhamento do período.',
    icon: LifeBuoy,
    module: 'recuperacao',
    verb: 'visualizar',
    route: '/gestao/recuperacao',
    grupo: 'Pedagógico',
    tone: 'amber',
  },
  {
    key: 'historico',
    label: 'Histórico Escolar',
    description: 'Histórico do Ensino Médio, emissões e conferência de registros.',
    icon: ScrollText,
    module: 'historicos',
    verb: 'visualizar',
    route: '/gestao/historico',
    grupo: 'Pedagógico',
    tone: 'sky',
  },
  {
    key: 'documentos',
    label: 'Documentos',
    description: 'Declarações e documentos DNA Sign — visualizar, gerar e imprimir.',
    icon: FileSignature,
    module: 'documentos',
    verb: 'visualizar',
    route: '/gestao/documentos',
    grupo: 'Documentos',
    tone: 'rose',
  },
  {
    key: 'calendario',
    label: 'Calendário',
    description: 'Eventos, feriados e reuniões do ano letivo — somente leitura.',
    icon: CalendarDays,
    module: 'calendario',
    verb: 'visualizar',
    route: '/gestao/calendario',
    grupo: 'Rotina',
    tone: 'orange',
    readOnly: true,
  },
  {
    key: 'dnago',
    label: 'DNA GO',
    description: 'Entrada, saída, autorizados e retirada em tempo real.',
    icon: DoorOpen,
    module: 'dnago',
    verb: 'visualizar',
    route: '/gestao/dnago',
    grupo: 'Rotina',
    tone: 'teal',
    alwaysAvailable: true,
  },
  {
    key: 'dnamapa',
    label: 'DNA Mapa',
    description: 'Necessidades de aprendizagem, intervenções e evolução por estudante.',
    icon: BrainCircuit,
    module: 'dnamapa',
    verb: 'visualizar',
    route: '/gestao/dna-mapa',
    grupo: 'Pedagógico',
    tone: 'violet',
    roles: ['coordenacao', 'direcao_pedagogica'],
  },
];

export const GESTAO_GRUPOS = ['Alunos', 'Pedagógico', 'Documentos', 'Rotina'];

export const TONES = {
  violet: { grad: 'from-violet-500 to-fuchsia-600', soft: 'bg-violet-50 text-violet-700', ring: 'group-hover:ring-violet-200' },
  emerald: { grad: 'from-emerald-500 to-teal-600', soft: 'bg-emerald-50 text-emerald-700', ring: 'group-hover:ring-emerald-200' },
  indigo: { grad: 'from-indigo-500 to-blue-600', soft: 'bg-indigo-50 text-indigo-700', ring: 'group-hover:ring-indigo-200' },
  amber: { grad: 'from-amber-500 to-orange-600', soft: 'bg-amber-50 text-amber-700', ring: 'group-hover:ring-amber-200' },
  sky: { grad: 'from-sky-500 to-cyan-600', soft: 'bg-sky-50 text-sky-700', ring: 'group-hover:ring-sky-200' },
  rose: { grad: 'from-rose-500 to-pink-600', soft: 'bg-rose-50 text-rose-700', ring: 'group-hover:ring-rose-200' },
  orange: { grad: 'from-orange-500 to-red-500', soft: 'bg-orange-50 text-orange-700', ring: 'group-hover:ring-orange-200' },
  teal: { grad: 'from-teal-500 to-emerald-600', soft: 'bg-teal-50 text-teal-700', ring: 'group-hover:ring-teal-200' },
};

// Permissão do módulo (admin vê tudo; `alt` cobre perfis legados; DNA GO é auto-liberado)
export function moduleAllowed(mod, { can, isAdmin, dnagoAutoGrant }) {
  if (isAdmin) return true;
  if (mod.roles) { try { return mod.roles.includes(JSON.parse(localStorage.getItem('user') || '{}').role); } catch { return false; } }
  if (mod.alwaysAvailable && dnagoAutoGrant) return true;
  if (can(mod.module, mod.verb)) return true;
  return !!(mod.alt && can(mod.alt.module, mod.alt.verb));
}
